import { render, staticRenderFns } from "./Scene7.vue?vue&type=template&id=1175c6ec&scoped=true"
import script from "./Scene7.vue?vue&type=script&lang=js"
export * from "./Scene7.vue?vue&type=script&lang=js"
import style0 from "./Scene7.vue?vue&type=style&index=0&id=1175c6ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1175c6ec",
  null
  
)

export default component.exports